import Vue from 'vue'
import Component from 'vue-class-component'
import moduleStore from '../../store/videoEditor'
import PageState from '../../store/state'
import { Prop, Watch } from 'vue-property-decorator'

@Component({
})
@moduleStore.initVuex({
  mutationNames: moduleStore.mutationNames,
  actionNames: moduleStore.actionNames
})
export default class Subtitles extends Vue {
  state = new PageState()
  @Prop({ default: () => { } })
  subtitleInfo: any;      // 字幕信息
  @Prop({ default: () => { } })
  shortPlayerStyle: any;  // 播放器样式
  @Prop({ default: () => [] })
  blurList: Array<any>;  // 高斯模糊区域列表
  @Prop({ default: () => 0 })
  currPlayTime: number;  // 当前播放时间
  @Prop({ default: () => 1 })
  fontsizeRatio: number;  // 字体大小和百分比的比例
  @Prop({ default: () => true })
  showText: Boolean;      // 是否显示文本
  @Prop({ default: () => '' })
  imgCoverUrl: String;    // 封面图片

  oldSubtitleInfo = {};
  imgUrl = '';  // 显示的图片

  @Watch('imgCoverUrl', { immediate: true })
  listenImgCoverUrl(val) {
    this.imgUrl = val;
  }

  @Watch('subtitleInfo', { deep: true })
  listenSubtitleInfo(val) {
    // 不是同一段文本，不更新
    if (!val['uuid'] || this.oldSubtitleInfo['uuid'] !== val['uuid']) {
      this.oldSubtitleInfo = { ...val };
      return;
    }
    for (const key in val) {
      if (Object.prototype.hasOwnProperty.call(val, key) && val[key] !== this.oldSubtitleInfo[key]) {
        this.subtitleDataChange(key, val[key]);
      }
    }
    this.oldSubtitleInfo = { ...val }
  }

  subtitleDataChange(name, val) {
    switch (name) {
      case 'fontFamily':
        this.updateSubtitle({ fontFamily: val })
        break;
      case 'fontColour':
        this.updateSubtitle({ fontColour: val })
        break;
      case 'alpha':
        // this.updateSubtitle({ fontColour: val })
        // const bga = colorTobga(this.subtitleInfo.fontColour, this.subtitleInfo.alpha);
        // console.log(opacityToHex(this.subtitleInfo.alpha))
        break;
      case 'fontPercent':
        const fontSize = Math.round(val * this.fontsizeRatio);
        this.updateSubtitle({ fontSize })
        break;
    }
  }

  updateSubtitle(config) {
    this.$emit('update-subtitle', config)
  }
}
